import * as React from 'react';

import classNames from 'classnames';
import { selectInputOnFocus } from '~/ERP/utils/input';

export const DEFAULT_DECIMAL = 2;

const DecimalInput = (
	props: React.InputHTMLAttributes<HTMLInputElement> & {
		allowEmpty?: boolean;
		negative?: boolean;
		hasError?: boolean;
		selectOnFocus?: boolean;
		onDecimalInput?: (value: string) => void;
	}
) => {
	const { onDecimalInput, allowEmpty, className, hasError, negative, selectOnFocus, style, ...inputProps } = props;

	return (
		<input
			className={classNames(className, { 'border-red-600 text-red-600': hasError })}
			style={hasError ? { ...(style || {}), outlineColor: 'red' } : style}
			type='text'
			onFocus={selectOnFocus ? selectInputOnFocus : undefined}
			{...inputProps}
			onChange={(event) => {
				const originalValue = event.currentTarget.value.replace(',', '.');
				if (allowEmpty && originalValue === '') {
					onDecimalInput?.(originalValue);
					return;
				}

				if (negative && originalValue === '-') {
					onDecimalInput?.(originalValue);
					return;
				}

				if (!originalValue || !originalValue.match(/^(-)?\d{1,}(\.\d{0,10})?$/)) {
					return;
				}

				onDecimalInput?.(originalValue);
			}}
		/>
	);
};

export default React.memo(DecimalInput);
